<template>
  <v-card class="screen-tab-filtering-controls">
    <screen-tab-filter-by-tags-control
      :selected-tag-ids.sync="hasTagModel"
      :available-tags="availableTags"
    />
    <screen-tab-filter-by-multiple-values-control
      :inputs.sync="hasKeywordModel"
      label="Filter by Keywords"
      combobox
    />
    <screen-tab-filter-by-multiple-values-control
      :inputs.sync="hasAuthorModel"
      label="Filter by Authors"
    />
    <screen-tab-filter-by-multiple-values-control
      :inputs.sync="hasPlacePublishedModel"
      label="Filter by Place Published"
    />
    <div class="actions">
      <action-button color="primary" @click="$emit('apply')">
        Apply
      </action-button>
    </div>
  </v-card>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import ScreenTabFilterByTagsControl from './ScreenTabFilterByTagsControl';
import ScreenTabFilterByMultipleValuesControl from './ScreenTabFilterByMultipleValuesControl';
import { Review, ReferenceFilteringInputDto } from '@/models';
import { cloneDeep } from 'lodash';

const buildInputModelGetter = (key, castOp = (value) => value) => {
  return {
    get: function () {
      return this.filteringInput[key];
    },
    set: function (value) {
      const newFilteringInput = cloneDeep(this.filteringInput);
      this.$set(newFilteringInput, key, castOp(value));
      this.$emit('update:filteringInput', newFilteringInput);
    },
  };
};

export default {
  name: 'ScreenTabFilteringControls',
  components: {
    ActionButton,
    ScreenTabFilterByTagsControl,
    ScreenTabFilterByMultipleValuesControl,
  },
  props: {
    filteringInput: {
      type: ReferenceFilteringInputDto,
      required: true,
    },
    review: {
      type: Review,
      required: true,
    },
  },
  emits: ['update:filteringInput', 'apply'],
  computed: {
    availableTags() {
      return this.review.tags;
    },
    hasTagModel: buildInputModelGetter('hasTag'),
    hasKeywordModel: buildInputModelGetter('hasKeyword'),
    hasAuthorModel: buildInputModelGetter('hasAuthor'),
    hasPlacePublishedModel: buildInputModelGetter(
      'hasPlacePublished'
    ),
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';

.screen-tab-filtering-controls {
  @extend .pa-4;

  display: grid;
  gap: 16px;

  .actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
